export default [
  "Enfermeria",
  "Análisis Clínico",
  "Auxiliar en Cuidados de Adultos Mayores",
  "Tecnicatura Superior en Instrumentación Quirúrgica",
];
